import { Head, Link } from "@inertiajs/react";
import { Plus, Upload, Users } from "lucide-react";

import { Button } from "@/components/ui/button";
import { ButtonGroup } from "@/components/ui/button-group";
import AppLayout from "@/layouts/app-layout";
import {
  importNewApprovalsWorkflowsPath,
  importNewSectorsPath,
  newSectorPath,
  sectorsPath,
} from "@/routes";
import type {
  BreadcrumbItem,
  Company,
  PagyMetadata,
  RansackFilters,
  Sector,
} from "@/types";

import { SectorsDataTable } from "./data-table";

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Sectores", href: sectorsPath() },
];

interface SectorsProps {
  data: {
    sectors: Sector[];
    pagy: PagyMetadata;
  };
  filters: RansackFilters;
  companies: Company[];
}

export default function Sectors({ data, filters, companies }: SectorsProps) {
  const { sectors, pagy } = data;

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Sectores" />
      <div className="flex h-full flex-1 flex-col gap-4 p-4">
        <div className="flex flex-col space-y-2">
          <h2 className="text-2xl font-bold">Sectores</h2>
          <p className="text-muted-foreground">
            Gestiona obras/sectores y su información clave
          </p>
        </div>
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div className="text-sm text-muted-foreground">
            Total: {pagy.count} sectores
          </div>
          <ButtonGroup>
            <Button asChild variant="outline">
              <Link
                href={importNewApprovalsWorkflowsPath()}
                className="whitespace-nowrap"
              >
                <Users className="h-4 w-4 mr-2" />
                Importar niveles de aprobación
              </Link>
            </Button>
            <Button asChild variant="outline">
              <Link href={importNewSectorsPath()}>
                <Upload className="h-4 w-4 mr-2" />
                Importar Excel
              </Link>
            </Button>
            <Button asChild>
              <Link href={newSectorPath()}>
                <Plus className="h-4 w-4 mr-2" />
                Nuevo Sector
              </Link>
            </Button>
          </ButtonGroup>
        </div>

        <SectorsDataTable
          sectors={sectors}
          pagy={pagy}
          filters={filters}
          companies={companies}
        />
      </div>
    </AppLayout>
  );
}
